"use strict";var s;exports.DaySuffixes=void 0,(s=exports.DaySuffixes||(exports.DaySuffixes={})).TH="th",s.ST="st",s.RD="rd",s.ND="nd";
//# sourceMappingURL=day-suffixes.enum.js.map
